import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getScriberequest } from "../../store/actions/scriberequests_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/scriberequests_enum";
import SingleView from "../../components/common/SingleView";
const ViewScriberequest = ({
  getScriberequest,
  match,
  scriberequest: { loading, scriberequest },
}) => {
  useEffect(() => {
    getScriberequest(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Scriberequests"
          mainLinkTitle="Scriberequests"
          mainLinkUrl="/scriberequests"
          activeLink="View"
        />
        {!loading ? (
          scriberequest && (
            <SingleView
              data={scriberequest}
              inputFields={inputFields}
              label="Scriberequest"
              link="scriberequests"
              id={scriberequest.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ scriberequest: state.scriberequest });

const mapDispatchToProps = { getScriberequest };

export default connect(mapStateToProps, mapDispatchToProps)(ViewScriberequest);
